import styled from 'styled-components';

export const CommonButton = ({
  click,
  text,
  theme,
}: {
  text: string;
  click?: () => void;
  theme?: string;
}) => {
  return (
    <ButtonContainer>
      <Button theme={theme} onClick={click}>
        <ButtonText theme={theme}>{text}</ButtonText>
      </Button>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  width: 100%;
`;

const Button = styled.button<{ theme?: string }>`
  width: 100%;
  background: ${({ theme }) =>
    theme === 'dark' ? '#201F1E' : 'linear-gradient(to left, #9b12ff, #5a0cd5)'};
  padding: 18px;
  padding-left: 0px;
  padding-right: 0px;

  border: none;
  border-radius: 10px;

  cursor: pointer;

  &:active {
    background: ${({ theme }) =>
      theme === 'dark' ? '#201F1E' : 'linear-gradient(to left, #9205f7, #5a0cd5 90%)'};

    span {
      top: 1px;
    }
  }
`;

const ButtonText = styled.span<{ theme?: string }>`
  color: ${({ theme }) => (theme === 'dark' ? 'rgba(170, 170, 170, 1)' : 'white')};
  font-size: 20px;
  position: relative;
  transition: top 0.1s ease;
  font-family: 'GmarketSans', Inter;
  font-weight: 500;

  @media screen and (max-width: 720px) {
    font-weight: 800;
  }
`;
